<script lang="ts" setup>
withDefaults(
	defineProps<{
		type?: string;
	}>(),
	{
		type: "default"
	}
);
</script>

<template>
	<span
		:class="`tag--${type}`"
		class="tag"
	><slot/></span>
</template>

<style lang="scss" scoped>
.tag {
	@apply bg-primary text-grey text-[10px] font-black uppercase px-[6px] py-[3px] rounded-full min-w-[21px]
  flex items-center justify-center;
}
</style>
